var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatrixPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      background: "rgb(31, 20, 24)",
      display: "block",
      position: "relative",
      shapeRendering: "auto"
    },
    width: 128,
    height: 128,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fontFamily: "courier new",
      fontSize: 25.6
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 25.6)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.4845778056678838s"
    }
  }, "\uFF24")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 51.2)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.3845778056678837s"
    }
  }, "\uFF2A")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 76.80000000000001)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.2845778056678838s"
    }
  }, "\uFF2D")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 102.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.1845778056678837s"
    }
  }, "\uFF2F")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 128)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.0845778056678839s"
    }
  }, "\u30CA")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 153.60000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.9845778056678838s"
    }
  }, "\u30EF")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 179.20000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.8845778056678838s"
    }
  }, "\uFF29")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 204.8)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.7845778056678838s"
    }
  }, "\uFF32")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 230.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.6845778056678837s"
    }
  }, "\u30CC")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 256)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.5845778056678838s"
    }
  }, "\u30E8")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.6 25.6)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.1746118205235476s"
    }
  }, "\u30F0")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.6 51.2)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.0746118205235478s"
    }
  }, "\u30AA")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.6 76.80000000000001)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.9746118205235477s"
    }
  }, "\u30AA")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.6 102.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.8746118205235476s"
    }
  }, "\u30AD")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.6 128)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.7746118205235476s"
    }
  }, "\u30EA")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.6 153.60000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.6746118205235476s"
    }
  }, "\u30C8")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.6 179.20000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.5746118205235476s"
    }
  }, "\u30CA")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.6 204.8)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.4746118205235476s"
    }
  }, "\uFF2C")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.6 230.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.37461182052354763s"
    }
  }, "\u30DF")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.6 256)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.2746118205235476s"
    }
  }, "\uFF2A")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.2 25.6)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.1590974297697936s"
    }
  }, "\u30BB")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.2 51.2)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.0590974297697935s"
    }
  }, "\u30EB")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.2 76.80000000000001)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.9590974297697936s"
    }
  }, "\uFF29")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.2 102.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.8590974297697935s"
    }
  }, "\u30A2")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.2 128)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.7590974297697936s"
    }
  }, "\uFF39")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.2 153.60000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.6590974297697936s"
    }
  }, "\u30DE")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.2 179.20000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.5590974297697936s"
    }
  }, "\u30B3")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.2 204.8)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.45909742976979356s"
    }
  }, "\u30F2")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.2 230.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.3590974297697936s"
    }
  }, "\uFF23")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.2 256)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.25909742976979355s"
    }
  }, "\uFF31")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.80000000000001 25.6)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.720879066012182s"
    }
  }, "\u30BF")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.80000000000001 51.2)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.620879066012182s"
    }
  }, "\u30B3")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.80000000000001 76.80000000000001)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.520879066012182s"
    }
  }, "\u30C8")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.80000000000001 102.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.420879066012182s"
    }
  }, "\uFF32")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.80000000000001 128)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.320879066012182s"
    }
  }, "\uFF24")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.80000000000001 153.60000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.220879066012182s"
    }
  }, "\u30E1")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.80000000000001 179.20000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.120879066012182s"
    }
  }, "\uFF2B")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.80000000000001 204.8)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.020879066012182s"
    }
  }, "\u30AA")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.80000000000001 230.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.920879066012182s"
    }
  }, "\uFF18")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.80000000000001 256)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.820879066012182s"
    }
  }, "\u30DB")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.4 25.6)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.5363455030781237s"
    }
  }, "\u30DB")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.4 51.2)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.4363455030781238s"
    }
  }, "\uFF3A")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.4 76.80000000000001)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.3363455030781237s"
    }
  }, "\u30B1")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.4 102.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.2363455030781236s"
    }
  }, "\uFF16")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.4 128)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.1363455030781235s"
    }
  }, "\u30EF")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.4 153.60000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.0363455030781237s"
    }
  }, "\u30BD")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.4 179.20000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.9363455030781237s"
    }
  }, "\uFF21")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.4 204.8)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.8363455030781237s"
    }
  }, "\u30EA")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.4 230.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.7363455030781236s"
    }
  }, "\u30C4")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.4 256)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.6363455030781237s"
    }
  }, "\uFF38")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 25.6)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.9800464008732768s"
    }
  }, "\u30C1")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 51.2)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.880046400873277s"
    }
  }, "\uFF25")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 76.80000000000001)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.7800464008732768s"
    }
  }, "\u30CC")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 102.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.6800464008732767s"
    }
  }, "\uFF18")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.5800464008732766s"
    }
  }, "\u30CA")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 153.60000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.4800464008732768s"
    }
  }, "\uFF29")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 179.20000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.380046400873277s"
    }
  }, "\uFF27")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 204.8)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.2800464008732768s"
    }
  }, "\u30E2")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 230.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.1800464008732767s"
    }
  }, "\u30B1")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 256)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.0800464008732769s"
    }
  }, "\u30AB")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.60000000000002 25.6)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.0026935383802136s"
    }
  }, "\u30D8")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.60000000000002 51.2)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.9026935383802136s"
    }
  }, "\uFF18")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.60000000000002 76.80000000000001)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.8026935383802136s"
    }
  }, "\u30B5")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.60000000000002 102.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.7026935383802135s"
    }
  }, "\uFF2C")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.60000000000002 128)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.6026935383802136s"
    }
  }, "\u30F2")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.60000000000002 153.60000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.5026935383802136s"
    }
  }, "\uFF2A")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.60000000000002 179.20000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.4026935383802136s"
    }
  }, "\u30B1")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.60000000000002 204.8)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.30269353838021357s"
    }
  }, "\uFF3A")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.60000000000002 230.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.2026935383802136s"
    }
  }, "\u30CE")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.60000000000002 256)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.10269353838021358s"
    }
  }, "\u30EA")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.20000000000002 25.6)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.3693316496508203s"
    }
  }, "\u30B7")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.20000000000002 51.2)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.2693316496508205s"
    }
  }, "\u30B1")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.20000000000002 76.80000000000001)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.1693316496508204s"
    }
  }, "\uFF2D")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.20000000000002 102.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.0693316496508203s"
    }
  }, "\u30A6")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.20000000000002 128)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.9693316496508203s"
    }
  }, "\u30CF")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.20000000000002 153.60000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.8693316496508203s"
    }
  }, "\uFF25")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.20000000000002 179.20000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.7693316496508203s"
    }
  }, "\u30E1")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.20000000000002 204.8)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.6693316496508204s"
    }
  }, "\uFF27")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.20000000000002 230.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.5693316496508203s"
    }
  }, "\uFF37")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.20000000000002 256)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.4693316496508203s"
    }
  }, "\u30CE")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.8 25.6)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.6824174164862948s"
    }
  }, "\u30F3")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.8 51.2)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.5824174164862947s"
    }
  }, "\u30B1")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.8 76.80000000000001)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.4824174164862949s"
    }
  }, "\u30F3")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.8 102.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.3824174164862948s"
    }
  }, "\uFF34")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.8 128)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.282417416486295s"
    }
  }, "\uFF11")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.8 153.60000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.1824174164862948s"
    }
  }, "\u30E8")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.8 179.20000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.0824174164862947s"
    }
  }, "\u30E9")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.8 204.8)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.9824174164862949s"
    }
  }, "\u30C8")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.8 230.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.8824174164862948s"
    }
  }, "\u30ED")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.8 256)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.7824174164862948s"
    }
  }, "\u30CF")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.4 25.6)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.7756058017645235s"
    }
  }, "\u30EC")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.4 51.2)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.6756058017645237s"
    }
  }, "\u30DB")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.4 76.80000000000001)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.5756058017645236s"
    }
  }, "\u30CA")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.4 102.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.4756058017645235s"
    }
  }, "\u30CF")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.4 128)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.3756058017645234s"
    }
  }, "\uFF36")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.4 153.60000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.2756058017645235s"
    }
  }, "\u30B9")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.4 179.20000000000002)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.1756058017645237s"
    }
  }, "\u30BD")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.4 204.8)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-1.0756058017645236s"
    }
  }, "\u30F0")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.4 230.4)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.9756058017645235s"
    }
  }, "\u30C1")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.4 256)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e02475",
    style: {
      animationDelay: "-0.8756058017645235s"
    }
  }, "\uFF29")), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  @keyframes ldp-matrix {\n    0% { opacity: 1; fill: #e0aa82;}\n    10% { opacity: 1; fill: #e02475; }\n    50% { opacity: 0}\n    100% { opacity: 0}\n  }\n  text {\n    animation: ldp-matrix 1s linear infinite;\n    transform: scaleX(-0.7);\n  }\n")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrixPink);
export default __webpack_public_path__ + "static/media/matrix-pink.502923256eb935122fc0dcb13bcb36c7.svg";
export { ForwardRef as ReactComponent };